var UitkLinkThemeMap = [['default', 'default'], ['inverse', 'inverse']];
var UitkLinkThemes = new Map(UitkLinkThemeMap);
var UitkLinkSizeMap = [['small', 'small'], ['medium', 'medium'], ['large', 'large']];
var UitkLinkSizes = new Map(UitkLinkSizeMap);
var UitkLinkAlignMap = [['left', 'left'], ['center', 'center'], ['right', 'right']];
var UitkLinkAligns = new Map(UitkLinkAlignMap);
export { UitkLinkAligns, UitkLinkSizes, UitkLinkThemes };